import { AntSelect } from 'controls/react/ant/ant-select/antSelect';
import React, { useEffect, useState } from 'react';
import { apiFetch } from 'framework/api';
import { CostCurrency, listCurrencies } from 'areas/cost/api';
import { AntSelectPropsPlain, AntSelectValue, fieldNamesTextValue } from 'controls/react/ant/ant-select/types';
import { translator } from 'core/localization';

import { i18n } from 'core/localization';

export type CurrencyDropDownProps = AntSelectPropsPlain<AntSelectValue> & {
	accountId?: string;
	defaultValue?: string;
};

export const CurrencyDropDown = (props: CurrencyDropDownProps) => {
	const { accountId, defaultValue, ...others } = props;
	const [currencies, setCurrencies] = useState<CostCurrency[]>([]);

	useEffect(() => {
		const load = async () => {
			const result = await apiFetch(listCurrencies(accountId));
			if (result.success) {
				setCurrencies(result.data);
			}
		};
		void load();
	}, [accountId]);

	useEffect(() => {
		if (!others.value) {
			others.onChange?.(
				defaultValue ?? 'NOK',
				currencies.find((x) => x.value == defaultValue),
			);
		}
	}, [currencies, others.value, defaultValue]);

	return (
		<AntSelect
			placeholder={i18n('Select...')}
			options={currencies}
			fieldNames={fieldNamesTextValue}
			defaultValue={defaultValue ?? 'NOK'}
			{...others}
		/>
	);
};
